var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFeedback = function SvgIconFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#iconFeedback_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fillOpacity: 0.12,
    rx: 3.333
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.36,
    d: "m7.86 13.463.202.117c.67.384 1.43.587 2.198.587a4.43 4.43 0 0 0 4.427-4.427 4.43 4.43 0 0 0-4.427-4.427A4.43 4.43 0 0 0 5.833 9.74c0 .767.203 1.527.587 2.197l.116.203-.661 1.985zm-3.632 2.309 1.175-3.525a5.46 5.46 0 0 1-.612-2.507 5.475 5.475 0 0 1 5.469-5.469 5.475 5.475 0 0 1 5.469 5.47 5.475 5.475 0 0 1-5.47 5.468c-.87 0-1.731-.211-2.506-.612z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconFeedback_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconFeedback;